<template>
  <div class="content">
    <!-- 基本信息 -->
    <div class="content-box content-scheme">
      <div class="supplies-box">
        <div class="supplies-list">
          <ul>
            <li>
              <div class="ub formContact-title item">
                <el-row :gutter="10" class="ub-f1">
                  <el-col :span="1">#</el-col>
                  <el-col :span="4">{{
                    $t('crm_contract_parts_consumables.chan_pin_xing_hao')
                  }}</el-col>
                  <el-col :span="2">{{
                   $t('crm_contract_parts_consumables.zu_lin_yue_shu')
                  }}</el-col>
                  <el-col :span="2">{{
                    $t('crm_contract_parts_consumables.zhi_fu_zhou_qi')
                  }}</el-col>
                  <el-col :span="2">{{
                    $t('crm_contract_parts_consumables.she_bei_lei_xing')
                  }}</el-col>
                  <el-col :span="3">{{
                    $t('crm_contract_parts_consumables.hao_cai_ming_cheng')
                  }}</el-col>
                  <el-col :span="2">{{
                    $t('crm_contract_parts_consumables.hao_cai_dai_ma')
                  }}</el-col>
                  <el-col :span="2">{{
                    $t('crm_contract_parts_consumables.hao_cai_shu_liang')
                  }}</el-col>
                  <el-col :span="3">{{
                    $t('crm_contract_parts_consumables.hcsqjgzqy')
                  }}</el-col>
                  <el-col :span="3">{{
                    $t('Common.com_handle')
                  }}</el-col>
                </el-row>
              </div>
            </li>
            <li v-for="(item, index) in stuffList" :key="index">
              <div class="item ub">
                <el-row :gutter="10" class="ub-f1">
                  <el-col :span="1">
                    <div class="index">
                       {{ index + 1 }}
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="code">
                        {{item.productCode}}
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <div class="code">
                      {{item.rentalTerm}}
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <div class="code">
                       {{getDicValue('crm_payment_period',item.paymentPeriod)  }}
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <div class="code">
                      {{item.deviceBizType}}
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <custom-select
                      url="smsGoodsSelectList"
                      :listener="`${item.productCode}`"
                      v-model="item.goodsSkuId"
                      :props="{ label: 'goodsName', value: 'goodsSkuId'}"
                      :params="{productCode:item.productCode}"
                      :placeholder="$t('Common.com_please_select')"
                      width="100%"
                      @change="onGoodsSelect(...arguments,item)"
                    ></custom-select>
                  </el-col>
                  <el-col :span="2">
                    <div class="code">
                      {{item.goodsCode}}
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <el-input
                      v-model.number="item.bookingNum"
                      style="width=100%;height=30px"
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <el-input
                      v-model="item.useInterval"
                      style="width=100%;height=30px"
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <div class="icon-box" @click="addStuffItem(index,item)">
                      <i class="icon icon-add"></i>
                    </div>
                    <div class="icon-box" @click="deleteStuffItem(index)">
                      <i class="icon icon-shanchu"></i>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </li>
          </ul>
        </div>
        <div class="lease-add-btn" @click="addSchemeItem">
          <div style="display: inline-block">
            <i class="icon icon-add"></i>
            <span>{{ $t('Common.com_added') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{$t('Common.com_cancel')}}</el-button>
      <!-- 租赁合同续租 -->
      <template v-if="backType==='continueOrder'">
        <el-button @click="preStep">{{$t('crm_contract_parts_consumables.sybxzzzsb')}}</el-button>
        <el-button type="primary" @click="saveScheme">{{ $t('crm_contract_parts_consumables.xybqrhtxx') }}</el-button>
      </template>
      <template v-else-if="backType==='testToRent'">
        <el-button @click="preStep">{{$t('crm_contract_parts_consumables.sybhtxx')}}</el-button>
        <el-button type="primary" @click="saveScheme">{{ $t('crm_contract_parts_consumables.xybqrhtxx') }}</el-button>
      </template>
      <template v-else>
        <el-button @click="preStep">{{$t('crm_contract_parts_consumables.sybxzzlfa')}}</el-button>
        <el-button type="primary" @click="saveScheme" v-if="contractInfo.signingMethod === 2">{{ $t('crm_contract_parts_consumables.xybsczzht') }}</el-button>
        <el-button type="primary" @click="saveScheme" v-if="contractInfo.signingMethod === 1">{{ $t('crm_contract_parts_consumables.xybxzdzht') }}</el-button>
      </template>
    </div>
    <!-- 添加产品型号 -->
    <contract-selectScheme
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="addSchemeSelect"
    ></contract-selectScheme>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import contractSelectScheme from './contract_selectScheme_dialog.vue';


export default {
  components: {
    contractSelectScheme
  },
  inject: ['getContractInfo'],
  computed: {
    contractInfo() {
      return this.getContractInfo();
    },
  },
  props: {
    backType: { type: String, default: '' },
    contractId: [String, Number],
    contractClass: [String, Number],
    operateFlag: [String],
  },

  data() {
    return {
      tableCode: 'contract_scheme_supplies',
      // 耗材列表
      stuffList: [],
      stuffItem: {
        // 订购数量
        bookingNum: '',
        // 货币单位
        currencyUnit: '',
        // 商品名称
        goodsName: '',
        // 商品代码
        goodsCode: '',
        // 销售商品SKU
        goodsSkuId: '',
        // 商品规格
        goodsSpec: '',
        // 产品型号
        productCode: '',
        // 售卖单价
        unitPrice: '',
        // 单位
        unit: '',
        // 允许使用的间隔（月）
        useInterval: '',
        // 租赁月数
        rentalTerm: 0,
        // 订单id
        orderGoodsId: '',
      },
      schemeList: [],
      productCodelist: [],
      // 选择收货地址
      // 添加设备
      dialogVisible: false,
      dialogModel: {},


      spanArr: []
    };
  },
  mounted() {
    // this.factoryId = this.getJump('factoryId');
    // this.contractId = this.contractId || '';
    this.getTableColumn();
    this.getSuppliesList();
  },
  methods: {
    // 获取方案列表
    getSchemeList: function () {
      this.$getJSON(apis.crmContractListScheme, { bizId: this.contractId, bizClass: this.contractClass }).then(
        (res) => {
          const data = res.data.goodsList ? res.data.goodsList : [];
          this.schemeList = data.map((i) => {
            const item = {};
            item.productCode = i.productCode;
            item.rentalTerm = i.rentalTerm;
            item.orderGoodsId = i.orderGoodsId;
            item.paymentPeriod = i.paymentPeriod;
            item.deviceBizType = i.deviceBizType;
            return item;
          });
          this.setStuffList();
        }
      );
    },
    // 获取耗材列表
    getSuppliesList: function () {
      this.$getJSON(apis.crmContractFrameOrderStuffList, { bizId: this.contractId, bizClass: this.contractClass }).then(
        (res) => {
          this.stuffList = res.data || [];
          // this.setStuffList();
          // 如果耗材为空 去取方案
          if (!this.stuffList.length) {
            this.getSchemeList();
          }
        }
      );
    },
    // 设置耗材列
    setStuffList: function () {
      this.stuffList = [];
      this.schemeList.forEach((i) => {
        const item = { ...this.stuffItem, productCode: i.productCode, rentalTerm: i.rentalTerm, orderGoodsId: i.orderGoodsId, paymentPeriod: i.paymentPeriod, deviceBizType: i.deviceBizType };
        this.stuffList.push(JSON.parse(JSON.stringify(item)));
      });
      this.listSort();
    },
    // 选择方案弹窗回调
    addSchemeSelect: function (list) {
      list.forEach((i) => {
        const listItem = { ...this.stuffItem, productCode: i.productCode, rentalTerm: i.rentalTerm, orderGoodsId: i.orderGoodsId, paymentPeriod: i.paymentPeriod, deviceBizType: i.deviceBizType };
        this.stuffList.push(JSON.parse(JSON.stringify(listItem)));
      });
      this.listSort();
    },
    // 根据型号月数排序
    listSort: function () {
      this.stuffList.sort((a, b) => {
        if (a.productCode === b.productCode) {
          return a.rentalTerm - b.rentalTerm;
        }
        return a.productCode - b.productCode;
      });
    },
    // 租赁方案
    saveScheme: function () {
      // 方案表单验证
      const hasEmpty = this.stuffList.find(
        t => t.goodsSkuId === '' || t.bookingNum === '' || t.useInterval === ''
      );
      if (hasEmpty) {
        this.$message.error(this.$t('crm_contract_parts_consumables.qjhclbtxwz'));
        return;
      }
      // 耗材数量不能小于0
      const negativeTotal = this.stuffList.find(
        t => +t.bookingNum <= 0
      );
      if (negativeTotal) {
        this.$message.error(this.$t('crm_contract_parts_consumables.hcslbnxy0'));
        return;
      }
      // 使用的间隔不能小于0
      const additionalFee = this.stuffList.find(
        t => +t.useInterval <= 0
      );
      if (additionalFee) {
        this.$message.error(this.$t('crm_contract_parts_consumables.sydjgbnxy0'));
        return;
      }
      // 耗材和方案重复
      const hasRepeat = this.stuffList.find((item, index) => {
        const flag = this.stuffList.some((inItem, inIndex) => inIndex !== index && inItem.orderGoodsId === item.orderGoodsId && inItem.goodsSkuId === item.goodsSkuId);
        return flag;
      });
      if (hasRepeat) {
        this.$message.error(this.$t('crm_contract_parts_consumables.fayhcbncf'));
        return;
      }
      // 保存更改租赁方案
      this.$postJSON(apis.crmContractSaveStuff, {
        bizClass: this.contractClass,
        bizId: this.contractId,
        operateFlag: this.operateFlag,
        stuffList: this.stuffList
      }).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('Common.com_save_success'),
            type: 'success',
          });
          // 上传纸质合同
          this.$emit('success',);
        }
      });
    },
    // 新增方案弹窗
    addSchemeItem: function () {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('crm_contract_parts_consumables.xzzlfa');
      this.dialogModel.contractId = this.contractId;
      this.dialogModel.contractClass = this.contractClass;
    },
    // 耗材下拉
    onGoodsSelect: function (data, item) {
      if (item.goodsSkuId) {
        this.$setFormatData(item, data);
      }
    },
    // 添加耗材项
    addStuffItem: function (index, oldItem) {
      const listItem = { ...this.stuffItem, productCode: oldItem.productCode, rentalTerm: oldItem.rentalTerm, orderGoodsId: oldItem.orderGoodsId };
      this.stuffList.splice(index + 1, 0, listItem);
    },
    // 删除方案项
    deleteStuffItem: function (index) {
      this.stuffList.splice(index, 1);
    },
    // 取消
    onCancel: function () {
      this.$emit('cancelJump');
    },
    preStep: function () {
      this.$emit('previous');
    },
  },
};
</script>

<style lang="scss">
@import "@/style/colors.scss";
.content-scheme {
  padding: 14px 24px 0;
  table {
    border-collapse: collapse;
  }
  .el-table .cell {
    // color: #FFFFFF;

    color: rgba(57, 70, 104, 1);
  }
  .el-table .el-table__row td {
    // display: inline-block;
    // width: 100%;
    margin-top: 16px;
    // background: #f5f5fa;
    color: rgba(57, 70, 104, 1);
    border: 0 !important;
  }
  .el-table tr {
    // background: #f5f5fa;
    border: 1px solid #f2f3fb;
    color: rgba(57, 70, 104, 1);
    th .cell {
      color: #636e78;
    }
  }
  .el-table__expanded-cell[class*="cell"] {
    padding: 0;
  }
  .tab-wrap {
    // padding: 0 24px;
    .wrap-form {
      background: #ffffff;
      padding: 10px 24px 0;
      .wrap-form-row {
        background: #ffffff;
        padding: 10px 14px 0;
        background: #f8f9fb;
      }
    }
    .rent-amount {
      background: #ffffff;
      padding: 0 8px;
      display: flex;
      li {
        width: 100px;
        margin: 20px 16px 12px;
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        height: 50px;
        .title {
          height: 16px;
          font-size: 12px;
          font-weight: bold;
          color: #495057;
          line-height: 16px;
        }
        .amount {
          margin-top: 6px;
          height: 28px;
          font-size: 12px;
          font-weight: bold;
          color: #0d9ae0;
          line-height: 28px;
        }
        &:last-of-type {
          border: 0;
        }
      }
    }
  }

  .lease-add-btn {
    line-height: 50px;
    text-align: center;
    color: rgba(73, 80, 87, 1);
    font-size: 12px;
    margin: 16px 0 16px;
    height: 50px;
    background: #f6f7fb;
    border: 1px dashed rgba(53, 184, 224, 0.3);
    cursor: pointer;
    span {
      line-height: 50px;
    }
    .icon {
      color: #00afff;
      font-size: 12px;
      margin-right: 8px;
      display: inline-block;
      line-height: 50px;
      height: 50px;
      // float: left;
    }
  }


  // .rule-action-bd {
  .supplies-list{
    ul li {
      margin-top: 10px;
      margin-bottom: 10px;
      // border: 1px solid rgba(228, 228, 228, 1);
      &:first-child {
        margin-top: 0;
      }
    }
    .formContact-title {
      // height: 30px;
      // line-height: 30px;
      background: rgba(228, 228, 228, 1);
      color: #636E78;
      font-size: 12px;
      // padding: 0 10px;
    }
    .item {
      padding: 10px;
      background: rgba(245, 245, 245, 1);
      border: 1px solid rgba(228, 228, 228, 1);
      .index,.code{
        line-height: 32px;
        height: 32px;
        color: #6C757D;
        width: 100%;
        font-size: 12px;
      }

      .icon-box {
        line-height: 32px;
        width: 32px;
        margin-left: 10px;
        text-align: center;
        display: inline-block;
        .icon {
          color: #00afff;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }

  }
  .add-child-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px dashed rgba(228, 228, 228, 1);
    line-height: 30px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin: 0 10px;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }
  .role-add-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px dashed rgba(228, 228, 228, 1);
    line-height: 40px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin-top: 10px;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }

}
</style>
